var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "collapse column" },
    [
      _c(
        "div",
        {
          staticClass: "header",
          on: {
            click: function($event) {
              _vm.active = !_vm.active
            }
          }
        },
        [
          _c("div", [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "arrow" },
            [
              _c("font-awesome-icon", {
                attrs: {
                  icon: _vm.active ? _vm.faChevronDown : _vm.faChevronUp
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "collapse", mode: "in-out" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.active,
                expression: "active"
              }
            ],
            staticClass: "content"
          },
          [_vm._t("default")],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d28bc1d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d28bc1d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Accordion.vue
// module id = null
// module chunks = 